export const COMPANY_TYPE_MEDIABUREAU = 'MediaBureau'
export const COMPANY_TYPE_HUMAN_RESOURCE_MANAGER = 'HumanResourceManager'
export const COMPANY_TYPE_DIRECT_EMPLOYER = 'DirectEmployer'
